import { type ScannerProfileType, type ModelsConfigType, type ScannerProfilesType, DecisionMode } from './tenant-configuration';

// https://github.com/barcoemu/tig-pat-research-notebooks/blob/master/wsi/roi_per_scanner_type.ipynb
export const supportedScannerProfilesDefaults: Record<string, ScannerProfileType> = {
  'gt450': {
    name: 'GT450',
    vendor: 'Leica',
    offset: {
      left: 11.0,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'at2': {
    name: 'AT2',
    vendor: 'Leica',
    offset: {
      left: 5.5,
      right: 3.5,
      top: 0.6,
      bottom: 0.6,
    },
  },
  'c13220': {
    name: 'C13220', // aka NanoZoomer S360
    vendor: 'Hamamatsu',
    offset: {
      left: 22.5, // label is not part of the macro
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'c13210': {
    name: 'C13210', // aka NanoZoomer S60
    vendor: 'Hamamatsu',
    offset: {
      left: 22.5, // label is not part of the macro
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
  'ventana dp 200': {
    name: 'DP200',
    vendor: 'Ventana',
    offset: {
      left: 22.5,
      right: 0.3,
      top: 0.3,
      bottom: 0.3,
    },
  },
};

export const defaultScannerProfile: ScannerProfileType = {
  name: 'Default',
  vendor: 'Barco',
  offset: {
    left: 11.0,
    right: 0.3,
    top: 0.3,
    bottom: 0.3,
  },
};

export const scannerProfilesDefaults: ScannerProfilesType = {
  default: defaultScannerProfile,
  ...supportedScannerProfilesDefaults,
};

export const defaultModelsConfig: ModelsConfigType = {
  schema_version: '1.1.0',
  detection: {
    scannerProfiles: {
      default: defaultScannerProfile,
    },
  },
  interpretation: {
    blur: {
      lowerThreshold: 0.17,
      upperThreshold: 0.30,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    missingTissue: {
      lowerThreshold: 0.2,
      upperThreshold: 1,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    misalignedCoverSlip: {
      lowerThreshold: 0.3,
      upperThreshold: 40,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    cutOffTissue: {
      lowerThreshold: 0.4,
      upperThreshold: 40,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
    markerOnTopOfTissue: {
      lowerThreshold: 4.2,
      upperThreshold: 10,
      automaticRescan: false,
      greenDecisionMode: DecisionMode.enum.AUTOMATIC,
      redDecisionMode: DecisionMode.enum.AUTOMATIC,
      excluded: false,
    },
  },
};
